import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Optional,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { EaButtonToggleChoice } from './pr-button-toggle-choice';

@Component({
    selector: 'pr-button-toggle',
    templateUrl: './pr-button-toggle.component.html',
    styleUrls: ['./pr-button-toggle.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PrButtonToggleComponent,
        },
    ],
    standalone: false
})
export class PrButtonToggleComponent
  implements AfterViewInit, OnChanges, ControlValueAccessor
{
  @Input() name: string;
  @Input() formControlName: string;
  @Input() derrors: boolean = false;
  @Input() choices: EaButtonToggleChoice[];
  @Input() value: any;
  @Input() selectedTextColor: string = 'black';
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  @ViewChild('indicator') indicator: ElementRef;
  @ViewChildren('labels') labels;

  private onChangeFn: any;
  private onTouchedFn: any;

  constructor(
    private renderer: Renderer2,
    @Optional() private controlContainer: ControlContainer,
  ) {}

  get control() {
    if (this.formControlName && this.controlContainer) {
      return this.controlContainer.control.get(this.formControlName);
    }
    return null;
  }

  ngAfterViewInit() {
    this.labels.changes.subscribe(() => {
      this.positionIndicator();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value']) {
      setTimeout(() => this.positionIndicator(), 0);
    }
  }

  private positionIndicator() {
    if (this.labels._results.length) {
      let label = this.labels._results.find(
        label => label.nativeElement.children[0].checked,
      );
      if (label) {
        this.renderer.setStyle(this.indicator.nativeElement, 'opacity', '1');
        this.renderer.setStyle(
          this.indicator.nativeElement,
          'width',
          label.nativeElement.offsetWidth + 'px',
        );
        this.renderer.setStyle(
          this.indicator.nativeElement,
          'transform',
          'translateX(' + label.nativeElement.offsetLeft + 'px)',
        );
      } else {
        this.renderer.setStyle(this.indicator.nativeElement, 'opacity', '0');
      }
    }
  }

  forwardChange(event) {
    let value = event.target.value;

    if (value === 'null' || value === '') value = null;
    else if (value === 'undefined') value = undefined;
    else if (value === 'true') value = true;
    else if (value === 'false') value = false;
    else if (!isNaN(Number(value)) && value !== '') value = Number(value);

    this.value = value;
    this.positionIndicator();
    this.onChange.emit(this.value);

    if (this.onChangeFn) {
      this.onChangeFn(this.value);
    }
    if (this.onTouchedFn) {
      this.onTouchedFn();
    }
  }

  writeValue(value: any): void {
    this.value = value;
    setTimeout(() => this.positionIndicator(), 0);
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }
}
